import { FC } from 'react'
import { LucideIcon } from '@/components/atoms/icons/lucideIcons'

export const SearchIcon: FC = () => (
  <LucideIcon>
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.3-4.3" />
  </LucideIcon>
)

export const SparklesIcon: FC<{ className?: string }> = ({ className }) => (
  <LucideIcon className={className}>
    <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z" />
    <path d="M20 3v4" />
    <path d="M22 5h-4" />
    <path d="M4 17v2" />
    <path d="M5 18H3" />
  </LucideIcon>
)

export const MicIcon: FC = () => (
  <LucideIcon>
    <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z" />
    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
    <line x1="12" x2="12" y1="19" y2="22" />
  </LucideIcon>
)

export const XIcon: FC = () => (
  <LucideIcon>
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </LucideIcon>
)

export const ChevronUpIcon: FC = () => (
  <LucideIcon>
    <path d="m18 15-6-6-6 6" />
  </LucideIcon>
)

export const Clock3Icon: FC = () => (
  <LucideIcon>
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16.5 12" />
  </LucideIcon>
)
